import { FC } from "react";
import { ReportsUIModel } from "./reportsModel";

interface UserLoginStatisticsReportTileProps {
  report: ReportsUIModel;
  parentSaysExpand?: boolean;
}

export const UserLoginStatisticsReportTile: FC<React.PropsWithChildren<UserLoginStatisticsReportTileProps>> = (props: UserLoginStatisticsReportTileProps) => {

  const report = props.report;

  return (
    <div className="report-tile col-md-6 col-12">
      <dl>
        <div>
          <dt>Report Name:</dt>
          <dd>{report.reportName}</dd>
        </div>
        <div>
          <dt>Type:</dt>
          <dd>{report.exportType}</dd>
        </div>
        <div>
          <dt>As Of:</dt>
          <dd>{report.asOfUtc}</dd>
        </div>
        <div>
          <dt>Format:</dt>
          <dd>{report.fileType}</dd>
        </div>
        <div>
          <dt>Status:</dt>
          <dd>{report.reportStatus}</dd>
        </div>
      </dl>
    </div>
  );
}
